const INGREDIENT_KEYWORDS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default INGREDIENT_KEYWORDS_INITIAL_STATE
